import { render } from "./singleInstitute.vue?vue&type=template&id=5181cb2c&ts=true"
import script from "./singleInstitute.vue?vue&type=script&lang=ts"
export * from "./singleInstitute.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__